import copy from 'copy-to-clipboard';
import Process from './Process.vue';
import { downloadSingle, downloadBatch } from '../utils';
export default {
  components: {
    Process
  },
  props: {
    file: {
      type: Object,
      default: () => ({
        size: 0,
        status: 'ready'
      })
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    saved() {
      if (this.file?.response?.data?.size) {
        const originSize = this.file.size;
        const {
          size
        } = this.file.response.data;
        return -((originSize - size) / originSize * 100).toFixed(2);
      }
      return 0;
    },
    isSuccess() {
      if (this.file?.response?.data?.images) {
        return true;
      }
      return false;
    },
    imagesUrlStr() {
      if (this.isSuccess) {
        return this.file.response.data.images.join('\n');
      }
      return '';
    },
    showCopyLink() {
      if (this.isSuccess) {
        return !/^(http:|https:)?(\/\/)?(localhost|yatu\.di6gan\.cn)/.test(this.imagesUrlStr);
      }
      return false;
    }
  },
  methods: {
    formatFileSize(size) {
      if (size) {
        return Math.round(size / 1024) + 'kb';
      }
      return '';
    },
    // 下载文件
    download() {
      const images = this.file.response.data.images;
      const name = this.file.name;
      const length = images.length;
      if (length === 1) {
        downloadSingle({
          src: images[0],
          name
        });
      } else if (length > 1) {
        downloadBatch(images);
      }
    },
    copyLink() {
      copy(this.imagesUrlStr);
    }
  }
};